"use client";

import { useRef } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useGSAP } from "@gsap/react";
import { Clock, ShieldCheck, ArrowRight, UserCheck, Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Link } from "@/components/common/Link";
gsap.registerPlugin(ScrollTrigger, useGSAP);
const highlights = [{
  icon: UserCheck,
  text: "Direct 1:1 Senior Consultation"
}, {
  icon: ShieldCheck,
  text: "No Junior Hand-offs"
}, {
  icon: Sparkles,
  text: "Custom SEO Growth Strategy"
}];
export default function Directaccess() {
  const containerRef = useRef<HTMLElement>(null);
  useGSAP(() => {
    const mm = gsap.matchMedia();
    mm.add("(prefers-reduced-motion: no-preference)", () => {
      gsap.from(".gsap-reveal", {
        opacity: 0,
        y: 28,
        stagger: 0.12,
        duration: 0.8,
        ease: "power3.out",
        scrollTrigger: {
          trigger: containerRef.current,
          start: "top 80%"
        }
      });
    });
    mm.add("(prefers-reduced-motion: reduce)", () => {
      gsap.set(".gsap-reveal", {
        opacity: 1,
        y: 0
      });
    });
  }, {
    scope: containerRef
  });
  return <section ref={containerRef} id="directaccesscallout" data-nav="dark" className="relative w-full overflow-hidden bg-foreground py-20 md:py-28 text-background">
      {}
      <div className="pointer-events-none absolute -top-24 left-1/2 -translate-x-1/2 size-96 rounded-full bg-accent/15 blur-3xl" />

      <div className="container relative z-10 mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-3xl text-center space-y-6 sm:space-y-8">
          {}
          <div className="gsap-reveal inline-block">
            <span className="text-xs font-semibold uppercase tracking-widest text-accent font-serif">
              Unfiltered Expertise
            </span>
          </div>

          {}
          <h1 className="gsap-reveal text-2xl sm:text-3xl lg:text-4xl font-bold font-serif text-background tracking-tight leading-tight">
            Direct Access. Zero Middleman Layers.
          </h1>

          {}
          <p className="gsap-reveal text-base sm:text-lg text-background/80 leading-relaxed font-sans max-w-2xl mx-auto">
            When you hire YE Consultancy, you work directly with me—Yassine Essaadi.
            No account managers, no junior delegates, and no communication barrier.
            Get hands-on SEO audits, strategy, and execution support directly from a
            dedicated search expert focused on your sustainable business growth.
          </p>

          {}
          <div className="gsap-reveal flex flex-col sm:flex-row items-center justify-center gap-4 pt-2">
            <Button size="lg" variant="outline" className="border-2 border-background bg-transparent text-background hover:bg-background hover:text-foreground font-semibold px-7 py-6 rounded-xl shadow-lg transition-all duration-300 hover:scale-105 group cursor-pointer" asChild>
              <Link to="/AboutMePage">
                <span>Schedule Direct Call</span>
                <ArrowRight className="ml-2 size-4 transition-transform group-hover:translate-x-1" />
              </Link>
            </Button>

            <Badge variant="outline" className="rounded-full border-accent/30 bg-accent/10 px-4 py-2 text-accent text-xs sm:text-sm font-medium backdrop-blur-xs flex items-center gap-2">
              <Clock className="size-3.5 text-accent" />
              <span>Response within 24 hours</span>
            </Badge>
          </div>

          {}
          <div className="gsap-reveal pt-8 sm:pt-10 border-t border-background/10 grid grid-cols-1 sm:grid-cols-3 gap-4 text-xs sm:text-sm text-background/70">
            {highlights.map((item, i) => {
            const Icon = item.icon;
            return <div key={i} data-index={i} className="flex items-center justify-center gap-2 py-1">
                  <Icon className="size-4 text-accent shrink-0" />
                  <span className="font-medium text-background/90">{item.text}</span>
                </div>;
          })}
          </div>
        </div>
      </div>
    </section>;
}